import styled from 'styled-components'

import { colors } from 'styles/theme'
export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`
export const SwitchWrapper = styled.div<{ isActive?: boolean }>`
  position: relative;
  width: 36px;
  height: 18px;
  background: ${(props) =>
    props.isActive ? colors.primary : colors.lightWhite};
  border: none;
  border-radius: 50px;
  padding: 4px;
  transition: 300ms all;
  &:before {
    transition: 300ms all;
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    top: 50%;
    left: 4px;
    background: ${colors.lightWhite1};
    transform: translate(0, -50%);
  }
`
export const Input = styled.input<{ isActive: boolean }>`
  opacity: 0;
  position: absolute;
  &:checked + ${SwitchWrapper} {
    &:before {
      transform: translate(136%, -50%);
      background: ${(props) =>
        props.isActive ? colors.white : colors.lightWhite};
    }
  }
`
